module.exports = {
  // 从数据库导入表单
  importFormFromDatabase: 'Import form from database',
  // 报表访问链接
  reportAccessLink: 'Report Access Link',
  // 根据部门选择用户
  selectUsersByDepartment: 'Select Users By Department',
  // 同步数据库
  synchronizeTheDatabase: 'Synchronize The Database',
  addExistingUser: 'Add existing user',//
  newAddUser: 'Add New User',// 新建用户
  rolePermissionsConfiguration: 'Role Permissions Configuration',// 角色权限配置
  departmentPermissionConfiguration: 'Department permission configuration',// 部门权限配置
  addSubmenu: 'Add submenu', // 添加子菜单
  dataPermissionRules: 'Data permission rules' // 数据权限规则
}